import { VDBText } from "@components/atoms";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import { Platform } from "react-native";

const LabelContainer = ({
  backgroundColor,
  productName,
  productColor,
  height = 24,
}: any) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  return (
    <Container backgroundColor={backgroundColor} height={height}>
      <VDBText
        type={typography["Minor-M"]}
        color={theme[productColor]}
        selectable={Platform.OS === "web"}
      >
        {t(productName ?? "")}
      </VDBText>
    </Container>
  );
};

const Container = styled.View<any>`
  background-color: ${({ theme, backgroundColor }) => theme[backgroundColor]};
  align-items: center;
  justify-content: center;
  padding-left: 6px;
  padding-right: 6px;
  border-radius: 7px;
  height: ${({ height }) => height}px;
`;

export default LabelContainer;
